// serializeTypes.js
export const FETCH_SERIALIZE_DETAIL_REQUEST = 'FETCH_SERIALIZE_DETAIL_REQUEST';
export const FETCH_SERIALIZE_DETAIL_SUCCESS = 'FETCH_SERIALIZE_DETAIL_SUCCESS';
export const FETCH_SERIALIZE_DETAIL_FAILURE = 'FETCH_SERIALIZE_DETAIL_FAILURE';
